export default __webpack_public_path__ + "static/media/logo_Mind.4aa56007.svg";